var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surround-box',{attrs:{"title":"荣昌区生猪年养殖规模"}},[_c('div',{staticClass:"chart-box"},[_c('div',{ref:"chart",staticClass:"chart"}),_c('div',{staticClass:"unit"},[_vm._v("单位："+_vm._s(_vm.unit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }